import { render, staticRenderFns } from "./TaskField.vue?vue&type=template&id=3ce58a4e&scoped=true"
import script from "./TaskField.vue?vue&type=script&lang=js"
export * from "./TaskField.vue?vue&type=script&lang=js"
import style0 from "./TaskField.vue?vue&type=style&index=0&id=3ce58a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce58a4e",
  null
  
)

export default component.exports